module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_M2-1c007fa2055e1348259cbbb104d54711.png";